import { nullable, struct } from 'io-ts/Decoder';

import { Id as OrganizationId } from '../../../../organization/Id';

export const Params = struct({
	organizationId: nullable(OrganizationId),
});
